import React, { useContext, useEffect, useState } from 'react';
import './AssociateMail.css'
import { Accordion, Card, Button, Collapse } from 'react-bootstrap'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowAltCircleDown, faArrowDown, faArrowUp, faCaretRight, faSortDown, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import AppContext from '../../Context/AppContext';
import { invertColor } from '../HR/TimeClock/Util';
import { Tooltip } from 'antd';
import { useSelector } from "react-redux";

const CollapsibleUI = ({data,onClick,flag,selected,open,selectedIds}) => {
   const [expandedKeys, setExpandedKeys] = useState({}); // State to track expanded sections
   const [Data,setData]=useState({});
   const [selectedIDs,setSelectedIds]=useState([]);
   const [change,setChange]=useState(Date.now());
   const AppData = useContext(AppContext);
   const { state, dispatch } = AppData || {}; 
   const AllDeals = useSelector((state) => state.AppReduxContext.AllDeals);
   
  useEffect(()=>{
    if(data && !_.isArray(data)){
        setData(data); 
        setChange(Date.now()); 
        if(selectedIds && !_.isArray(selectedIds)){
        const ROWIDs=extractSelectedTaskROWIDs(selectedIds);
        setSelectedIds(ROWIDs)
        }
    }
  },[flag,data,open])
  function extractSelectedTaskROWIDs(records) {
    const rowIds = [];  
      Object.values(records).forEach(pipelines => {
        Object.values(pipelines).forEach(tasks => {
          tasks.forEach(task => {
            if (task.selected === true) {
              rowIds.push(task.TaskROWID);
            }
          });
        });
      }); 
    return rowIds;
  }
   
  const handleToggle = (key) => {
    setExpandedKeys((prev) => ({
      ...prev,
      [key]: !prev[key],  
    }));
  };

  const renderSubtasks = (subtasks,dealName,pipelineKey,task) => {
    if (!subtasks) return null;
    return (
      <div className="subtasks">
        {subtasks.map((subtask, subtaskIndex) => (
          <div key={subtaskIndex} className="subtask Elipsis-Class" onClick={e=>{
            let SubtaskData={...task};
            SubtaskData["SubTasks"]=[subtask];
            onClick({[dealName]:{[pipelineKey]:[SubtaskData],TagExtraItem:Data[dealName]['TagExtraItem']}})}}>
            <span>{subtask.TaskName}</span>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="collapsible-container">
      {change && Object.keys(Data)?.map((dealName, dealIndex) => {
          const account = state?.AllAccounts?.find(el => Data[dealName]['dealObj']?.Account_Name?.id === el.id);  
          const accountColor = account?.Color || 'rgb(32, 173, 255)';
          const invertedColor = accountColor=='rgb(32, 173, 255)'?'#fff':invertColor(accountColor, true);  
          return selected ? Object.keys(Data[dealName])?.map((pipelineKey) => {
            if (pipelineKey === 'dealObj' || pipelineKey === 'TagExtraItem') return null;
  
            return Data[dealName][pipelineKey]?.map((task, taskIndex) => {
              const showTask = task.selected;
              const hasSubtasks = Array.isArray(task.SubTasks) && task.SubTasks.length > 0;
  
              return (
                <React.Fragment key={`${dealName}-${pipelineKey}-${taskIndex}`}>
                  {showTask && (
                    <div className="task-list">
                      <div className="collapsible-label Elipsis-Class" style={{ position: 'relative' }}>
                        <Tooltip
                          title={
                            <div>
                              <strong>Account Name:</strong>{' '}
                              {AllDeals?.find((r) => r?.Deal_Name === dealName)?.Account_Name?.name}
                              <br />
                              <strong>Deal Name:</strong> {dealName}
                              <br />
                              <strong>Pipeline Name:</strong> {pipelineKey?.split('_')[0]}
                              <br />
                              <strong>Task:</strong> {task.TaskName}
                            </div>
                          }
                          placement="top"
                        >
                          <div
                            style={{
                              marginLeft: '0.8em',
                              paddingRight: '20px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {task.TaskName}
                          </div>
                        </Tooltip>
                        <div
                          style={{
                            position: 'absolute',
                            top: '7%',
                            right: '2%',
                            cursor: 'pointer',
                            width: '5%',
                          }}
                        >
                          <FontAwesomeIcon
                            onClick={(e) => {
                              e.stopPropagation();
                              let taskData={...task}
                              delete taskData.SubTasks;
                              onClick({ [dealName]: { [pipelineKey]: [taskData] } });
                            }}
                            className="Delete-Icon-For-Field"
                            color="red"
                            icon={faTimes}
                          />
                        </div>
                      </div>
                    </div>
                  )}
  
                  {hasSubtasks &&
                    task.SubTasks.map((subTask, subIndex) => (
                      <div className="task-list" key={`${task.TaskROWID}-sub-${subIndex}`}>
                        <div className="collapsible-label Elipsis-Class" style={{ position: 'relative' }}>
                          <Tooltip
                            title={
                              <div>
                                <strong>Account Name:</strong>{' '}
                                {
                                  AllDeals?.find((r) => r?.Deal_Name === dealName)
                                    ?.Account_Name?.name
                                }
                                <br />
                                <strong>Deal Name:</strong> {dealName}
                                <br />
                                <strong>Pipeline Name:</strong> {pipelineKey?.split('_')[0]}
                                <br />
                                <strong>SubTask:</strong> {subTask.TaskName}
                              </div>
                            }
                            placement="top"
                          >
                            <div
                              style={{
                                marginLeft: '0.8em',
                                paddingRight: '20px',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap',
                              }}
                            >
                              {subTask.TaskName}
                            </div>
                          </Tooltip>
                          <div
                            style={{
                              position: 'absolute',
                              top: '7%',
                              right: '2%',
                              cursor: 'pointer',
                              width: '5%',
                            }}
                          >
                            <FontAwesomeIcon
                              onClick={(e) => {
                                e.stopPropagation();
                                let SubtaskData={...task};
                                 SubtaskData["SubTasks"]=[subTask];
                                onClick({[dealName]: {[pipelineKey]: [SubtaskData]}});
                              }}
                              className="Delete-Icon-For-Field"
                              color="red"
                              icon={faTimes}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                </React.Fragment>
              );
            });
          }):
          <div key={dealIndex} className="collapsible-section">
          <div className="collapsible-label Elipsis-Class" onClick={() => handleToggle(dealName)}>
            {Object.keys(Data[dealName]).length > 0 && (
              <div style={{position: 'absolute',left: 0,top: 0}}><FontAwesomeIcon icon={expandedKeys[dealName] ? faSortDown : faCaretRight}/></div>
            )}
            <div style={{marginLeft: '0.8em'}}><span className='nametile' style={{background: accountColor,color: invertedColor}}>{Data[dealName]['TagExtraItem']?Data[dealName]['TagExtraItem']['Accounts']:''}
                </span> / <span className='nametile' style={{background:"rgb(32, 173, 255)",color:'#fff'}}>{dealName}</span></div>
          </div>
          {expandedKeys[dealName] && (
            <div className="pipeline-list">
              {Object.keys(Data[dealName]).map((pipelineKey, pipelineIndex) => (
                (pipelineKey!='dealObj' && pipelineKey!='TagExtraItem') &&
                <div key={pipelineIndex} className="collapsible-section">
                  <div className="collapsible-label Elipsis-Class" onClick={() => handleToggle(pipelineKey)}>
                    {Data[dealName][pipelineKey].length > 0 && (
                        <div style={{position: 'absolute',left: 0,top: 0}}><FontAwesomeIcon icon={expandedKeys[pipelineKey] ? faSortDown : faCaretRight}/></div>
                    )}
                    <div style={{marginLeft: '0.8em'}}>{pipelineKey?.split('_')[0]}</div>
                  </div>
                  {expandedKeys[pipelineKey] && (
                    <div className="task-list">
                      {Data[dealName][pipelineKey].map((task, taskIndex) => (
                        <div key={taskIndex} className="collapsible-section">
                          <div className="collapsible-label Elipsis-Class" style={{position:'relative'}} onClick={() => handleToggle(task.TaskROWID)}>
                            {task.SubTasks && task.SubTasks.length > 0 && (
                                <div style={{position: 'absolute',left: 0,top: 0}}><FontAwesomeIcon icon={expandedKeys[task.TaskROWID] ? faSortDown : faCaretRight}/></div>
                            )}
                            <div onClick={()=>{
                              let taskData={...task};
                              taskData['selected']=true;
                              delete taskData.SubTasks;
                              onClick({[dealName]:{[pipelineKey]:[taskData],TagExtraItem:Data[dealName]['TagExtraItem']}})
                              }}
                              style={selectedIDs.includes(task.TaskROWID)?{marginLeft: '0.8em',opacity:'0.5'}:{marginLeft: '0.8em'}}>
                              {task.TaskName}</div>
                            {/* <div style={{position: 'absolute',top: '7%',right: '2%',cursor: 'pointer',width: '5%'}}>
                                {<FontAwesomeIcon onClick={e => onClick({[dealName]:{[pipelineKey]:[task]}})}  
                            className='Delete-Icon-For-Field' color='red' icon={faTimes}></FontAwesomeIcon>}</div> */}
                          </div>
                          {expandedKeys[task.TaskROWID] && renderSubtasks(task.SubTasks,dealName,pipelineKey,task)}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      })}
    </div>
  );
}; 

export default CollapsibleUI;
